export const SHOPIFY_API_VERSION = '2026-07'

export const shopifyAdminApiUrl = (storeDomain: string) =>
  `${storeDomain}/admin/api/${SHOPIFY_API_VERSION}/graphql.json`
